import { apiFetch, setToken } from "./client";

interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponseData {
  access_token: string;
  expires_in: number;
  device_id: string;
  user: {
    id: string;
    email: string;
    display_name: string;
    custom_id: string | null;
  };
}

export async function login(
  credentials: LoginRequest,
): Promise<LoginResponseData> {
  const res = await apiFetch<{ data: LoginResponseData }>("/auth/login", {
    method: "POST",
    body: JSON.stringify({
      email: credentials.email,
      account_password: credentials.password,
      device_id: getOrCreateDeviceId(),
      turnstile_token: "admin-console",
      public_key: "ops-console-no-e2ee",
      platform: "web",
      device_name: "Ops Console",
    }),
  });
  setToken(res.data.access_token);
  return res.data;
}

function getOrCreateDeviceId(): string {
  // Hardcoded to the device_id that was authorized during test setup.
  // Generating a random one would trigger PENDING_DEVICE_LIMIT since
  // the admin console has no device authorization flow.
  return "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa";
}
